import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { deleteAddress } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

const AddressDeleteButton = ({
  dispatchDeleteAddress,
  disabled,
  addressId,
}) => {
  const [showModal, setShowModal] = useState(false);
  const onClickDelete = () => dispatchDeleteAddress({ addressId });
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

AddressDeleteButton.propTypes = {
  dispatchDeleteAddress: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  addressId: PropTypes.number.isRequired,
};

AddressDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteAddress: deleteAddress,
};

export default connect(null, mapDispatchToProps)(AddressDeleteButton);
